import React, { Dispatch, SetStateAction } from 'react';
import { CalendarChallenge } from 'src/types/shared/Challenge';
import CalendarGanttBar from './CalendarGanttBar';
import { calendarBarColors } from '@constants/calendar';

const CalendarGanttBars: React.FC<CalendarGanttBarProps> = ({
    challenge,
    calendarStartDate,
    calendarEndDate,
}) => {
    const {
        id,
        workshopDate,
        startDate,
        endDate,
        assessmentStartDate,
        responseDate,
        pitchPresentationDate,
    } = challenge;

    // Challenge stages stored in types/shared/Challenge > challengeStages

    return (
        <>
            <CalendarGanttBar
                id={id}
                stage={'workshop'}
                barStartDate={workshopDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.workshop}
                challenge={challenge}
                isExpanded
            />
            <CalendarGanttBar
                id={id}
                stage={'livechallenge'}
                barStartDate={startDate}
                barEndDate={endDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.livechallenge}
                challenge={challenge}
                isExpanded
            />
            <CalendarGanttBar
                id={id}
                stage={'assessment'}
                barStartDate={assessmentStartDate}
                barEndDate={responseDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.assessment}
                challenge={challenge}
                isExpanded
            />
            <CalendarGanttBar
                id={id}
                stage={'pitch'}
                barStartDate={pitchPresentationDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.pitch}
                challenge={challenge}
                isExpanded
            />
        </>
    );
};

interface CalendarGanttBarProps {
    challenge: CalendarChallenge;
    calendarStartDate: Date | string;
    calendarEndDate: Date | string;
}

export default CalendarGanttBars;
